<span [matTooltip]="email" class="user">{{name | async}}</span>
